// First/last-touch attribution helper for visitor sessions.
const FIRST_KEY = "cws_attr_first";
const LAST_KEY = "cws_attr_last";

export interface Attribution {
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  content?: string;
  referrer?: string;
  landing_path?: string;
  ts: string;
}

function readUtm(): Partial<Attribution> {
  const sp = new URLSearchParams(window.location.search);
  const has =
    sp.has("utm_source") || sp.has("utm_medium") || sp.has("utm_campaign");
  if (!has) return {};
  return {
    source: sp.get("utm_source") || undefined,
    medium: sp.get("utm_medium") || undefined,
    campaign: sp.get("utm_campaign") || undefined,
    term: sp.get("utm_term") || undefined,
    content: sp.get("utm_content") || undefined,
  };
}

export function captureAttribution(): { first: Attribution | null; last: Attribution | null; hasUtm: boolean } {
  const utm = readUtm();
  const hasUtm = Object.keys(utm).length > 0;
  const landing = window.location.pathname + window.location.search;
  const referrer = document.referrer || undefined;

  let first: Attribution | null = null;
  try {
    const raw = localStorage.getItem(FIRST_KEY);
    first = raw ? (JSON.parse(raw) as Attribution) : null;
  } catch {}

  if (!first) {
    first = { ...utm, referrer, landing_path: landing, ts: new Date().toISOString() };
    try { localStorage.setItem(FIRST_KEY, JSON.stringify(first)); } catch {}
  }

  let last: Attribution | null = first;
  if (hasUtm) {
    last = { ...utm, referrer, landing_path: landing, ts: new Date().toISOString() };
    try { localStorage.setItem(LAST_KEY, JSON.stringify(last)); } catch {}
  } else {
    try {
      const raw = localStorage.getItem(LAST_KEY);
      if (raw) last = JSON.parse(raw) as Attribution;
    } catch {}
  }
  return { first, last, hasUtm };
}

export function getAttribution(): { first: Attribution | null; last: Attribution | null } {
  let first: Attribution | null = null;
  let last: Attribution | null = null;
  try {
    const f = localStorage.getItem(FIRST_KEY);
    if (f) first = JSON.parse(f);
    const l = localStorage.getItem(LAST_KEY);
    if (l) last = JSON.parse(l);
  } catch {}
  return { first, last: last || first };
}
